// import React, { useState, useMemo } from 'react';
import styled from '@emotion/styled';
import SplitPane from 'react-split-pane';


/**
 * @deprecated Use SplitPane from @imminently/decisively-ui/SplitPane instead.
 * @type { React.FC< any > }
 */
export const Resizable = styled(SplitPane)`
  .Resizer {
    background: none;
    /* width: 1px; */
    height: 100%;
    cursor: url(/slider.svg) 16 16, col-resize;
    /* border-left: 1px solid var(--border); */
    padding: 2px;
    z-index: 5; // ensure draws above pane 2, and graph
    transition: background-color .2s cubic-bezier(.785,.135,.15,.86) .2s;
    contain: strict;

    &:hover {
      background-color: var(--border);
    }

    &:before {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      background-color: var(--border);
      width: 1px;
      left: 0;
    }
  }

  .Pane2 {
    margin-left: -4px; // offset resize handle padding
  }

  &.disabled {
    .Resizer {
      cursor: default;
    }
  }
`;